import React from 'react';
import c from '../sideBar/dashboard.module.css';

const Header = (props) => {
    const {title} = props;

    // Pages built on PageLayout render their own title block, so they pass no
    // title here and this collapses rather than leaving an empty bar.
    if (!title) return null;

    return (
        <div className={c.headerContainer}>
            <div className={c.headerRow}>
                <div className={c.headerContent}>
                    <div className={c.headerTitle}>
                        <h4> {title} </h4>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Header;